import * as R from 'ramda'

export const isEmpty = R.anyPass([R.isNil, R.isEmpty])
